import styled from "styled-components";
import { Player } from "@lottiefiles/react-lottie-player";
import { mobile, tablet } from "./util/breakpoints";
import lottie from "./assets/6/6.json";
import backBar from "./assets/6/6-back-bar.png";
import { useRef } from "react";
import { Zoom, Fade } from "react-reveal";

const Container = styled.div`
  background: #504ab8;
  padding: 224px 39px;
  position: relative;

  display: grid;
  grid-template-columns: 1fr 577px 1fr;

  ${tablet`
    padding: 110px 40px;
    grid-template-columns: 1fr 400px 1fr;

  `}

  ${mobile`
    display: flex;
    flex-direction: column;
    padding: 70px 36px;
  `}
`;

const MiddleBarWrapper = styled.div`
  position: absolute;
  bottom: 50%;
  left: 50%;
  margin-left: -288px;
  width: 577px;
  z-index: 0;
  ${tablet`
    display: none;
  `}

  ${mobile`
    display: none;
  `}
`;

const MiddleBar = styled.img`
  width: 100%;
  z-index: 0;
`;

const Lottie = styled(Player)`
  position: relative;
  width: 372px;
  z-index: 3;

  ${tablet`
    width: 407px;
  `}

  ${mobile`
    width: 202px;
  `}
`;

const LeftText = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: 33px;
  line-height: 49px;
  text-align: right;
  font-feature-settings: "liga" off;
  color: white;
  display: flex;
  justify-content: center;
  margin-right: 93px;
  flex-direction: column;

  ${tablet`
    font-size: 25px;
    line-height: 37px;
    margin-right:47px;
  `}

  ${mobile`
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    margin-right: 0;
    margin-bottom: 30px;
  `}
`;

const MobileBR = styled.br`
  display: none;
  ${mobile`
    display: inline;
  `}
`;
const RightText = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: 21px;
  line-height: 31px;
  text-align: left;
  font-feature-settings: "liga" off;
  color: white;
  display: flex;
  justify-content: center;
  margin-left: 93px;
  flex-direction: column;

  ${tablet`
    font-size: 15px;
    line-height: 22px;
    margin-left: 47px;
  `}

  ${mobile`
    font-size: 9px;
    line-height: 13px;
    text-align: center;
    margin-left: 0;
    margin-top: 59px;
  `}
`;

export const Section6 = () => {
  const lottieRef = useRef(null);
  return (
    <Container>
      <LeftText>
        <Fade bottom>
          <p>Travel movie clips</p> <p>pin-pointed on a map,</p>
          <br />
          <p>See what experiences</p> <p>are nearby!</p>
        </Fade>
      </LeftText>
      <div style={{ position: "relative", zIndex: 3 }}>
        <Zoom
          center
          fraction={0.5}
          onReveal={() => {
            setTimeout(() => {
              lottieRef.current && lottieRef.current?.play();
            }, 0);
          }}
        >
          <Lottie ref={lottieRef} src={lottie} keepLastFrame />
        </Zoom>
      </div>
      <RightText>
        <Fade bottom>
          <p>Thousands of themes of travel experience videos all on a map.</p>
          <br />
          <p>
            Preview of all the things to do and eat after. Planning your trip
            becomes easier!
          </p>
        </Fade>
      </RightText>
      <MiddleBarWrapper>
        <Fade bottom>
          <MiddleBar src={backBar} />
        </Fade>
      </MiddleBarWrapper>
    </Container>
  );
};
